
export function genId(len=6, chars="ABCDEFGHIJKLMNOPQRSTWXYZabcdefghijklmnopqrstwxyz") {
  let id = "";
  while(len) {
    id += chars[(Math.random() * chars.length) | 0]
    len--;
  }
  return id;
}
